// @flow
import {Col} from "react-bootstrap"
import React from "react"
import PropTypes from "prop-types"

import id from "@irati/utils/id"
import Button from "@irati/ui/src/Button"
import searchError from "@irati/ui/images/search_error.svg"
import {H4} from "@irati/ui/src/Typography/Heading"
import RowMargin from "./styled/RowMargin"
import Img from "./styled/Img"

const ErrorState = (props) => {
  const {retry} = props
  const idNamespace = id("error-state", props)
  return (
    <RowMargin id={idNamespace}>
      <Col sm={2} md={1}><Img id={id("image", idNamespace)} src={searchError} alt="nothing found" /></Col>
      <Col sm={10} md={11}>
        <H4 id={id("title", idNamespace)}>Oh snap!</H4>
        <p id={id("copy", idNamespace)}>
          Something went wrong. You can totally try again!
        </p>
        <Button id={id("btn-retry", idNamespace)} onClick={() => retry()}>Try again</Button>
      </Col>
    </RowMargin>
  )
}

ErrorState.propTypes = {
  retry: PropTypes.func.isRequired
}
export default ErrorState
